import React, { useMemo } from 'react';
import FarmMegaMenuSidebar from './FarmMegaMenuSidebar';
import FarmMegaMenuContent from './FarmMegaMenuContent';

export default function FarmMegaMenu({
  open,
  macroCategories,
  activeMacroId,
  onSelectMacro,
  onViewGroup,
  onViewCrop,
  onMouseEnter,
  onMouseLeave,
  t,
  activeCategory,
  searchTerm,
  labelForMacro,
  labelForGroup,
  labelForCrop
}) {
  const safeLabelForMacro =
    typeof labelForMacro === 'function'
      ? labelForMacro
      : (macro) => macro?.name || '';
  const safeLabelForGroup =
    typeof labelForGroup === 'function'
      ? labelForGroup
      : (group) => group?.name || '';
  const safeLabelForCrop =
    typeof labelForCrop === 'function'
      ? labelForCrop
      : (crop) => String(crop || '');

  const activeMacro = useMemo(
    () => macroCategories.find((macro) => macro.id === activeMacroId) || macroCategories[0] || null,
    [macroCategories, activeMacroId]
  );

  if (!open || !activeMacro) return null;

  return (
    <div
      className="absolute left-0 right-0 top-full z-40"
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div className="overflow-hidden rounded-b-xl border border-t-0 border-gray-200 dark:border-neutral-800 bg-gray-50 dark:bg-neutral-900 shadow-[0_22px_48px_rgba(0,0,0,0.14)] dark:shadow-[0_22px_48px_rgba(0,0,0,0.55)]">
        <div className="flex min-h-[420px]">
          <FarmMegaMenuSidebar
            macroCategories={macroCategories}
            activeMacroId={activeMacro.id}
            onSelectMacro={onSelectMacro}
            labelForMacro={safeLabelForMacro}
          />

          <FarmMegaMenuContent
            macroCategory={activeMacro}
            onViewGroup={onViewGroup}
            onViewCrop={onViewCrop}
            t={t}
            activeCategory={activeCategory}
            searchTerm={searchTerm}
            labelForGroup={safeLabelForGroup}
            labelForCrop={safeLabelForCrop}
          />
        </div>
      </div>
    </div>
  );
}
